module.exports = __webpack_public_path__ + "img/deliver-img-2-3.df5ee2dc.png";